import { render, staticRenderFns } from "./HistoryBalance.vue?vue&type=template&id=740ea970&"
import script from "./HistoryBalance.vue?vue&type=script&lang=js&"
export * from "./HistoryBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports